import React from 'react';
import PropTypes from 'prop-types';
import capitalize from 'lodash/capitalize';
import replace from 'lodash/replace';

import Avatar from 'shared-components/Avatar/Avatar';
import styles from './TeamMember.module.css';

const formatName = (name) => name && replace(name, /\w+/g, capitalize);

const TeamMember = ({ member, userId, captainId, avatar }) => {
  const { name, invitedByName, userId: memberId } = member;
  return (
    <div className={styles.teamMember} key={memberId}>
      <Avatar url={avatar} className={styles.avatar} />
      <div className={styles.text}>
        <p>{`${formatName(name)}${userId === memberId ? ' (Me)' : ''}`}</p>
        {memberId === captainId ? (
          <span>
            <i className="fal fa-crown" style={{ marginRight: '6px' }} />
            Hosting Member
          </span>
        ) : (
          <span>{`Invited by ${formatName(invitedByName)}`}</span>
        )}
      </div>
    </div>
  );
};

TeamMember.propTypes = {
  userId: PropTypes.number.isRequired,
  member: PropTypes.shape({
    name: PropTypes.string.isRequired,
    userId: PropTypes.number.isRequired,
    invitedByName: PropTypes.string,
  }).isRequired,
  avatar: PropTypes.string,
  captainId: PropTypes.number.isRequired,
};

TeamMember.defaultProps = {
  avatar: null,
};

export default TeamMember;
